import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightSvg } from '~/svg';
import MyCampaignRequests from '~/components/Dashboard/Cards/MyCampaignRequests';
import ApplicationsForFinalReview from '~/components/Dashboard/Cards/ApplicationsForFinalReview';
import TopCampaigns from '~/components/Dashboard/Cards/TopCampaigns';
import UpcomingEvents, { IUpcomingEvent } from '~/components/Dashboard/Cards/UpcomingEvents';
// import FeaturedCampaigns from '~/components/Dashboard/Cards/FeaturedCampaigns'; // Commented out - Featured Campaigns hidden
import CardStaff from './Cards/CardStaff';
import { useAuth } from '~/context/AuthProvider';

interface DashboardStatsProps {
    dashboardStats?: any;
    upcomingEvents?: IUpcomingEvent[];
    eventsLoading?: boolean;
}

const PatientServicesCoordinatorDashboard: React.FC<DashboardStatsProps> = ({
    dashboardStats,
    upcomingEvents = [],
    eventsLoading = false,
}) => {
    const { user } = useAuth();
    const pscStats = dashboardStats?.psc_stats;
    
    // Check if user has administrator role
    const isAdministrator = user?.roles?.includes('administrator');

    return (
        <>
            {isAdministrator && (
                <section>
                    <div className='mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
                        <h2 className='text-xl font-semibold text-black dark:text-white'>
                            My Staff ({dashboardStats?.psc_count})
                        </h2>

                        <Link
                            to='/users?staff_only=true'
                            className='flex items-center gap-2 text-primary'
                        >
                            View All <ArrowRightSvg />
                        </Link>
                    </div>

                    <div className='mb-7.5 grid grid-cols-12 gap-7.5'>
                        {pscStats.map((pscStat, i) => {
                            return (
                                <CardStaff
                                    key={i}
                                    campaign_requests_count={
                                        pscStat.campaign_requests_count
                                    }
                                    campaigns_count={pscStat.campaigns_count}
                                    name={pscStat.name}
                                />
                            );
                        })}
                    </div>
                </section>
            )}

            <section className='grid grid-cols-12 gap-7.5'>
                <div className='col-span-12 mb-7.5 xl:col-span-4'>
                    <MyCampaignRequests />
                </div>
                <div className='col-span-12 mb-7.5 xl:col-span-8'>
                    <ApplicationsForFinalReview />
                </div>
            </section>

            <section className='grid grid-cols-12 gap-7.5'>
                <div className='col-span-12 mb-7.5 xl:col-span-8'>
                    <TopCampaigns />
                </div>

                <div className='col-span-12 mb-7.5 xl:col-span-4'>
                    <UpcomingEvents events={upcomingEvents} loading={eventsLoading} />
                </div>
            </section>

            {/* COMMENTED OUT: Featured Campaigns section hidden
            {isAdministrator && (
                <section className='mb-7.5'>
                    <FeaturedCampaigns />
                </section>
            )}
            */}
        </>
    );
};

export default PatientServicesCoordinatorDashboard;
